export enum AdSizeCode {
    SM = 0,
    MD = 1,
    LG = 2
}

export type AdBannerAsset = {
    id: string
    bannerId: string
    sizeCode: AdSizeCode
    imageUrl: string
    width?: number | null
    height?: number | null
    updatedAt?: string | null
}

export type AdZone = {
    id: string
    code: string
    displayName: string
    isEnabled: boolean
    updatedAt?: string | null
    banner?: AdBanner | null
}

export type AdBanner = {
    id: string
    zoneId: string
    isActive: boolean
    startAt?: string | null
    endAt?: string | null
    updatedAt?: string | null
    assets: AdBannerAsset[]
}